import type { BreakpointKey } from "@ui/tokens/grid";

import { breakpoints } from "@ui/tokens/grid";
import * as React from "react";

export function useIsWidthMin(breakpoint: BreakpointKey) {
  const breakpointValue = breakpoints[breakpoint];

  const [isMobile, setIsMobile] = React.useState(() => {
    // Only run on client side
    if (typeof window === "undefined") return undefined;

    const mql = window.matchMedia(`(min-width: ${breakpointValue})`);
    return !mql.matches;
  });

  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${breakpointValue})`);

    const onChange = () => {
      setIsMobile(!mql.matches);
    };

    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [breakpointValue]);

  return !!isMobile;
}

export function useIsMobile() {
  return useIsWidthMin("md");
}

export function useIsLargeOrAbove() {
  return !useIsWidthMin("lg");
}
